jQuery(document).ready(function(e) {

    if (jQuery('.page-template-scores-practice').length > 0) {
        // JavaScript code to handle showing/hiding matches based on active day

        // Get the current UTC date
        const currentDate = new Date();

        // Convert the current date to UTC
        const currentUTCDate = new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate());

        // Get all the day buttons
        const dayButtons = document.querySelectorAll('.scoring-round');

        // Get all the match day elements
        const matchDays = document.querySelectorAll('.practice__day');

        // Find the index of the active day
        let activeDayIndex;

        // Function to handle updating the matches based on the active day
        function updateMatches(activeIndex) {
            // Hide all match days
            matchDays.forEach((day) => {
                day.style.display = 'none';
            });

            // Show the match day corresponding to the active day
            matchDays[activeIndex].style.display = 'block';
        }

        // Function to handle changing the active day
        function changeActiveDay(index) {
            // Update the active day index
            activeDayIndex = index;

            // Update the matches based on the active day
            updateMatches(activeDayIndex);

            // Update the active state for the day buttons
            dayButtons.forEach((button, i) => {
                button.classList.toggle('active', i === activeDayIndex);
            });

            // Update the selected option in the select element
            const selectElement = document.getElementById('practice-days');
            selectElement.selectedIndex = activeDayIndex;

            // Trigger Select2 change event to update Select2's UI
            jQuery(selectElement).trigger('change');
        }

        // Add event listener for the select element
        const selectElement = document.getElementById('practice-days');
        jQuery(selectElement).on('select2:select', (event) => {
            const selectedDate = new Date(event.params.data.id);

            // Convert the selected date to UTC
            const selectedUTCDate = new Date(selectedDate.getUTCFullYear(), selectedDate.getUTCMonth(), selectedDate.getUTCDate());

            // Find the index of the selected day
            dayButtons.forEach((button, index) => {
                const buttonDate = new Date(button.getAttribute('attr-date'));

                // Convert the button date to UTC
                const buttonUTCDate = new Date(buttonDate.getUTCFullYear(), buttonDate.getUTCMonth(), buttonDate.getUTCDate());

                if (selectedUTCDate.getTime() === buttonUTCDate.getTime()) {
                    // The selected date matches the button date
                    changeActiveDay(index);
                }
            });
        });

        // Add event listeners for the day buttons
        dayButtons.forEach((button, index) => {
            button.addEventListener('click', () => {
                changeActiveDay(index);

                // Update the selected option in the select element
                selectElement.selectedIndex = index;

                // Trigger Select2 change event to update Select2's UI
                jQuery(selectElement).trigger('change');
            });

            const buttonDate = new Date(button.getAttribute('attr-date'));

            // Convert the button date to UTC
            const buttonUTCDate = new Date(buttonDate.getUTCFullYear(), buttonDate.getUTCMonth(), buttonDate.getUTCDate());

            if (currentUTCDate.getTime() >= buttonUTCDate.getTime()) {
                // The current date is equal to or after the button date
                changeActiveDay(index);
            } else if (activeDayIndex === undefined && currentUTCDate.getTime() < buttonUTCDate.getTime()) {
                // The current date is before all the button dates
                changeActiveDay(index);
            }
        });
    }

});
